var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 46.2 30",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m46.2 25.2c0 2.4-2 4.3-4.4 4.3h-37.4c-2.4 0-4.4-2-4.4-4.3v-20.4c0-2.4 2-4.3 4.4-4.3h37.5c2.4 0 4.4 2 4.4 4.3v20.4z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#384152"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.9 3.1-10.5 5.5v2.2h20.9v-2.2zm-7.8 9.8h2.2v7.7h-2.2zm6.8 0h2.2v7.7h-2.2zm6.6 0h2.2v7.7h-2.2zm-16 9.9h21v2.2h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 13.6h3.8c.7 0 1.3.1 1.7.4s.7.8.7 1.4c0 .4-.1.8-.3 1s-.4.5-.9.7c.4.1.9.3 1.1.7.2.3.3.8.3 1.3 0 .3-.1.5-.2.9-.1.2-.3.5-.5.7s-.5.3-.9.4c-.3.1-.8.2-1.3.2h-3.6v-7.6h.1zm1.4 3.3h2.3c.3 0 .7-.1.9-.3s.3-.4.3-.8-.1-.7-.3-.9c-.2-.1-.4-.2-.9-.2h-2.3zm0 3.5h2.4c.4 0 .8-.1 1-.3s.3-.5.3-.9-.1-.7-.3-.9-.5-.3-1-.3h-2.4zm6.2-6.8h6.4v1.2h-2.6v6.6h-1.4v-6.6h-2.5v-1.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.b285f178.svg";
export { ForwardRef as ReactComponent };